'use es6';

import Widget from 'DesignData/models/widgets/Widget';
import I18n from 'I18n';
import { omit } from 'underscore';

const getLabel = type => I18n.text(`designdata.widgetCatalog.widgets.${type}.title`);
/**
 * Represent structural widgets - widgets that organize other widgets.
 * E.g. cell, widget_container, virtual_cell
 */


export default class StructuralWidget extends Widget {
  /**
   * @constructor
   */
  constructor(_props) {
    const props = omit(_props, 'label');
    return super(props);
  }

  get label() {
    return getLabel(this.type);
  }
  /**
   * Returns an object widget with minimum requirements for use in a layout's tree.
   *
   * @override
   * @return {Object}
   */


  generateNewLayoutWidgetObject() {
    const {
      overrideable,
      params
    } = this;
    const superWidgetObject = super.generateNewLayoutWidgetObject();
    return Object.assign({}, superWidgetObject, {
      params: Object.assign({}, superWidgetObject.params, {}, params.without(['type']), {
        overrideable
      })
    });
  }

}